(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ListViewController', [
            'angular-inview',
            'MW.CoreStream',
            'MW.ContactManager.ContactManagerNavigationService',
            'MW.Framework.InfluencerContactService',
            'MW.Framework.TranslationService',
            'MW.Framework.ContactFilter',
            'MW.Framework.ContentStreamSelectionDecorator',
            'MW.Influencers.IcmDialogService',
            'MW.ContactManager.ContactManagerFlashService',
            'MW.CoreStream.ContactManagerTagService',
            'MW.Framework.ContentStreamDataFactory',
            'MW.Framework.CoreUserService',
            'MW.Framework.ICMEmailService',
            'MW.Framework.AppBarTitleService',
            'MW.ContactManager.ContactManagerActionBarFactory',
            'MW.CoreStream.CsSelectAllHeader',
            'MW.Influencers.SegmentTrackingService',
            'MW.Influencers.ActionBarService',
            'MW.Configuration',
            'ngMaterial',
            'MW.Influencers.MediaListEngagementWidget',
            'MW.ContactManager.MwMediaListUpdateModal',
            'MW.Framework.ICMEntitlementService',
            'MW.Influencers.MiniProfileService'
        ])
        .controller('ListViewController', [
            '$q',
            'ContactManagerNavigationService',
            'InfluencerContactService',
            'translationService',
            'DialogService',
            'ContactManagerFlashService',
            'ContactManagerTagService',
            'ContentStreamSelectionDecorator',
            'ContactStreamDataFactory',
            'DEFAULT_MEDIA_LIST',
            'CoreUserService',
            'ICMEmailService',
            '$location',
            'AppBarTitleService',
            'ContactManagerActionBarFactory',
            'ICM_RECIPIENTS_PER_DISTRIBUTION',
            'MAX_MEDIALIST_LIMIT',
            '$translate',
            '$timeout',
            '$mdDialog',
            '$mdToast',
            '$scope',
            'SegmentTrackingService',
            'ActionBarService',
            '$routeParams',
            'ICMEntitlementService',
            'ICM_CONTACT_SOURCE_SERVICE_API_KEY',
            'ICM_CONTACT_SERVICE_URL',
            'CONTACT_MANAGER_MEDIA_LIST_URL',
            'MiniProfileService',
            ListViewController
        ]);

    function ListViewController(
        $q,
        ContactManagerNavigationService,
        InfluencerContactService,
        translationService,
        DialogService,
        ContactManagerFlashService,
        ContactManagerTagService,
        ContentStreamSelectionDecorator,
        ContactStreamDataFactory,
        DEFAULT_MEDIA_LIST,
        CoreUserService,
        ICMEmailService,
        $location,
        AppBarTitleService,
        ContactManagerActionBarFactory,
        ICM_RECIPIENTS_PER_DISTRIBUTION,
        MAX_MEDIALIST_LIMIT,
        $translate,
        $timeout,
        $mdDialog,
        $mdToast,
        $scope,
        SegmentTrackingService,
        ActionBarService,
        $routeParams,
        ICMEntitlementService,
        ICM_CONTACT_SOURCE_SERVICE_API_KEY,
        ICM_CONTACT_SERVICE_URL,
        CONTACT_MANAGER_MEDIA_LIST_URL,
        MiniProfileService
        ) {
        this.ICM_RECIPIENTS_PER_DISTRIBUTION = ICM_RECIPIENTS_PER_DISTRIBUTION;
        this.MAX_MEDIALIST_LIMIT = MAX_MEDIALIST_LIMIT;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.$mdDialog = $mdDialog;
        this.SegmentTrackingService = SegmentTrackingService;
        this.ActionBarService = ActionBarService;
        this.$mdToast = $mdToast;
        this.ICM_CONTACT_SOURCE_SERVICE_API_KEY = ICM_CONTACT_SOURCE_SERVICE_API_KEY;
        this.ICM_CONTACT_SERVICE_URL = ICM_CONTACT_SERVICE_URL;
        this.CONTACT_MANAGER_MEDIA_LIST_URL = CONTACT_MANAGER_MEDIA_LIST_URL;
        this.MiniProfileService = MiniProfileService;
        this.$scope = $scope;

        var pageTitle = 'Influencers';
        translationService.getLocalizedString(pageTitle, null, true)
            .then(function setLocalizedTitle(localizedString) {
                pageTitle = localizedString;
            })
            .catch(function() {})
            .finally(function() {
                AppBarTitleService.setCurrentTitle(pageTitle);
            });

        this.DEFAULT_MEDIA_LIST = DEFAULT_MEDIA_LIST;
        this.$q = $q;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.translationService = translationService;
        this.DialogService = DialogService;
        this.ContactManagerFlashService = ContactManagerFlashService;
        this.ContactManagerTagService = ContactManagerTagService;
        this.InfluencerContactService = InfluencerContactService;
        this.CoreUserService = CoreUserService;
        this.ICMEmailService = ICMEmailService;
        this.$location = $location;
        this.ContactSelector = new ContentStreamSelectionDecorator({
            idField: 'id',
            filterName: 'contactFilter'
        });
        this.ICMEntitlementService = ICMEntitlementService;
        this.ICMEntitlementService.getIcmContactExportLimit()
        .then(entitlementLimit => {
            this.exportLimit = entitlementLimit;
        });

        this.ContactManagerActionBarFactory = new ContactManagerActionBarFactory(this.ContactSelector);

        this.ContactStreamData = new ContactStreamDataFactory();

        this.findString = '';
        this.findFilterExpanded = false;
        this.findFilterPromise = null; //promise for find filter debounce

        this.filters = {
            unsubscribe: false
        };
        this.filterOptionsHeader = this.$translate.instant('Filters');
        this.filterOptionsUnsubscribed = this.$translate.instant('Unsubscribed');
        this.filterEmptyText = this.$translate.instant('icm-web__empty-state--empty-filter');
        this.clearFilterOption = this.$translate.instant('icm-web__empty-state--clear-filter');

        this.streamHeaderTextValues = {
            filteredByUnsubscribeSortedByLastName: this.$translate.instant('icm-search__stream-header-text--filter-unsubscribed-and-sort-last-name'),
            sortedByLastName: this.$translate.instant('icm-search__stream-header-text--sort-last-name'),
            filteredByUnsubscribeSortedBySource: this.$translate.instant('icm-search__stream-header-text--filter-unsubscribed-and-sort-source'),
            sortedBySource: this.$translate.instant('icm-search__stream-header-text--sort-source')
        };

        this.successEditListToastMessage = this.$translate.instant('icm-web__media-lists--toast-list-updated');

        this.streamHeaderText = this.streamHeaderTextValues.sortedByLastName;
        this.sortMenuSubHeader = this.$translate.instant('icm-search__menu-header--sort-by');
        this.sortByOptions = {
            lastName: {
                display: this.$translate.instant('icm-search__sort-by--last-name'),
                value: 'lastName'
            },
            source: {
                display: this.$translate.instant('icm-search__sort-by--source'),
                value: 'source'
            }
        };
        this.selectedSortBy = this.sortByOptions.lastName.value;
        this.sortOrderOptions = {
            ascending: {
                display: this.$translate.instant('icm-search__sort-order--ascending'),
                value: 'ascending'
            },
            descending: {
                display: this.$translate.instant('icm-search__sort-order--descending'),
                value: 'descending'
            }
        };
        this.selectedSortOrder = this.sortOrderOptions.ascending.value;

        this.anyKeywords = '';

        this.defaultMasterListId = '';
        this.defaultMasterListName = 'All Contacts';
        this.totalMediaListContacts = 0;
        this.isLoadingContacts = true;

        //Code to show/hide Welcome Module
        CoreUserService.getCurrent(true).then(function(){
            entitlementPromises.push(this.ICMEntitlementService.getIcmCountriesEntitlement());
            entitlementPromises.push(this.ICMEntitlementService.getInfluencerAppEntitlement());

            $q.all(entitlementPromises)
                .then(function(results) {
                    this.isInfluencerDatabaseEntitled = (results[0] && (results[0].length > 0));
                    this.isInfluencerAppEntitled = (results[1]);
                }.bind(this))
                .finally(function() {
                    this.checkingActionPanelEntitlements = false;
                }.bind(this));
        }.bind(this));

        // CHECK ALL ENTITLEMENTS FOR THE SIDE ACTION PANEL
        // do some waiting to reduce flicker
        var entitlementPromises = [];
        this.checkingActionPanelEntitlements = true;
        this.isInfluencerDatabaseEntitled = false;
        this.isInfluencerAppEntitled = false;

        this.selectedMediaList = false;
        this.allContacts = false;

        this.translationService.getLocalizedString('All Contacts', null, true)
            .then(function setLocalizedAllContacts(localizedString) {
                this.allContactsLabel = localizedString;
            }.bind(this))
            .catch(function() {});

        this.isPermissions = false;
        this.CoreUserService.hasPermissions().then(function (isPermissions) {
            this.isPermissions = isPermissions;
        }.bind(this))
            .catch(function() {});

        this.selectedMediaListId = $routeParams.listId;
        this.setMediaList(this.selectedMediaListId);

        this.actions = [
            {
                name: 'edit_list',
                label: this.$translate.instant('icm-web__action-bar--edit-list'),
                icon: 'meltwater:edit',
                onClick: ()=> { this.showEditDialog(); },
                enabled: this.selectedMediaListId, // do not show this on all contacts
                doNotDisableActions: true
            },
            {
                name: 'outreach',
                label: this.$translate.instant('icm-web__action-bar--send-outreach'),
                icon: 'communication:ic_email_24px',
                onClick: ()=> { this.composeEmailToList(this.selectedMediaListId); },
                enabled: this.isOutreachActionEnabled(),
                doNotDisableActions: true
            },
            {
                name: 'add_contact',
                label: this.$translate.instant('icm-contact-add-landing__breadcrumb-title'),
                icon: 'social:ic_person_add_24px',
                onClick: ()=>{ this.ContactManagerNavigationService.goToContactAddLanding('influencers/contact/landing'); },
                enabled: true
            },
            {
                name: 'search',
                label: this.$translate.instant('icm-contact-add-landing__action-search-contacts--action'),
                icon: 'action:ic_search_24px',
                onClick: ()=>{ this.ContactManagerNavigationService.goToSearch(); },
                enabled: true
            },
            {
                label: this.$translate.instant('icm-web__action-bar--all-contacts'),
                icon: 'social:ic_group_24px',
                onClick: ()=>{ this.ContactManagerNavigationService.goToAllContactsList(); },
                enabled: !!this.selectedMediaListId
            }
        ];
        this.ActionBarService.registerActions(this.actions);

        function closeMini() {
            let _this = angular.element(document.getElementsByClassName('contactListPage')).scope().listController;
            _this.MiniProfileService.closeMiniProfile();
            _this.$scope.$apply();
        }

        window.addEventListener('app-chrome-drawer-closed', closeMini, false);
        this.$scope.$on('$locationChangeStart', function(event, next) { // PAGE CHANGE
            if (!next.includes('/contact-list')) {
                window.removeEventListener('app-chrome-drawer-closed', closeMini, false);
            }
        }.bind(this));
}

    ListViewController.prototype.isListFiltered = function isListFiltered() {
        return (this.filters.unsubscribe === true) || (this.findString.length > 0);
    };

    ListViewController.prototype.isEmptyStateVisible = function isEmptyStateVisible() {
        return !this.isLoadingContacts && (this.totalMediaListContacts < 1) && !this.isListFiltered();
    };

    ListViewController.prototype.clearFilters = function clearFilters() {
        this.findString = '';
        this.findFilterExpanded = false;
        this.filters.unsubscribe = false;

        if(this.selectedMediaListId) {
            this.getContactsByMediaListId(this.selectedMediaListId);
        } else {
            this.getMasterListOfContacts();
        }
    };

    ListViewController.prototype.selectedUnsubscribeFilter = function selectedUnsubscribeFilter() {
        // need to make sure we toggle this setting before calling to retrieve the contacts
        // the methods to get the contacts depend on this setting
        this.filters.unsubscribe = !this.filters.unsubscribe;

        if(this.selectedMediaListId) {
            this.getContactsByMediaListId(this.selectedMediaListId);
        } else {
            this.getMasterListOfContacts();
        }
    };

    ListViewController.prototype.updateSort = function updateSort(sortBy, sortOrder) {
        if(sortBy && sortBy.value) {
            this.selectedSortBy = sortBy.value;
        }

        if(sortOrder && sortOrder.value) {
            this.selectedSortOrder = sortOrder.value;
        }

        if(this.selectedMediaListId) {
            this.getContactsByMediaListId(this.selectedMediaListId);
        } else {
            this.getMasterListOfContacts();
        }
    };

    ListViewController.prototype.updateStreamHeaderText = function updateStreamHeaderText() {
        if(this.selectedSortBy === this.sortByOptions.lastName.value) {
            this.streamHeaderText = this.filters.unsubscribe ?
                this.streamHeaderTextValues.filteredByUnsubscribeSortedByLastName :
                this.streamHeaderTextValues.sortedByLastName;
        } else if(this.selectedSortBy === this.sortByOptions.source.value) {
            this.streamHeaderText = this.filters.unsubscribe ?
                this.streamHeaderTextValues.filteredByUnsubscribeSortedBySource :
                this.streamHeaderTextValues.sortedBySource;
        }
    };

    ListViewController.prototype.isOutreachActionEnabled = function isOutreachActionEnabled() {
        return !!this.selectedMediaListId && (this.totalMediaListContacts <= this.ICM_RECIPIENTS_PER_DISTRIBUTION);
    };

    ListViewController.prototype.setMediaList = function setMediaList(mediaListId) {
        if(mediaListId) {
            this.ContactManagerTagService.getMediaListById(this.selectedMediaListId).then((medialistObject) => {
                this.mediaListName = medialistObject.name;
                this.mediaListDescription = medialistObject.description;
                this.mediaListUpdatedDate = medialistObject.updated;
                this.mediaListCreatedDate = medialistObject.created;

                this.ActionBarService.registerTitle(medialistObject.name);
                this.ActionBarService.setBackButtonVisibility(true);
                this.getContactsByMediaListId(mediaListId);
            });
        } else {
            this.allContacts = true;
            this.mediaListName = this.$translate.instant('All Contacts');
            this.ActionBarService.registerTitle(this.mediaListName);
            this.ActionBarService.setBackButtonVisibility(true);
            this.getMasterListOfContacts();
        }
    };

    ListViewController.prototype.addContact = function addContact() {
        this.ContactManagerNavigationService.goToAdd();
    };

    ListViewController.prototype.showActionButtons = function showActionButtons() {
        return Object.keys(this.ContactSelector.selectedItems).length > 0;
    };

    ListViewController.prototype.deleteContacts = function deleteContacts() {
        var contactIds = Object.keys(this.ContactSelector.selectedItems);
        if(this.ContactSelector.trueAllSelected) {
            contactIds = [];
        }

        this.openDeleteContactsConfirmDialog(contactIds, this.selectedMediaListId, this.findString);
    };

    ListViewController.prototype.exportContactsToCSV = function exportContactsToCSV(ev) {
        var isAllContacts = (this.mediaListName === this.defaultMasterListName),
            csvFileName = this.ContactSelector.isAllSelected() ? (isAllContacts ? this.allContactsLabel : this.mediaListName) : 'contacts',
            numberOfContacts = this.ContactSelector.trueAllSelected ? this.ContactStreamData.totalContacts : Object.keys(this.ContactSelector.selectedItems).length;

        csvFileName = csvFileName.replace(/[#%&\{\}\\<>\*\?\/\$!'":@\+`\|=]/g, '-');
        if((this.ContactSelector.trueAllSelected && this.ContactStreamData.totalContacts > this.exportLimit) || Object.keys(this.ContactSelector.selectedItems).length > this.exportLimit) {
            this.$translate('icm-export__exceed-limit-message', {limit: this.exportLimit}).then(function(tooLargeMessage) {
                this.$translate('Selection Too Large').then(function(tooLargeTitle) {
                    this.DialogService.alert(tooLargeMessage, tooLargeTitle);
                }.bind(this))
                    .catch(function() {});
            }.bind(this))
                .catch(function() {});
        } else {
            this.$mdDialog.show(
                this.$mdDialog.mwAlert()
                    .class('legal-message')
                    .textContent(this.$translate.instant('icm-export__legal-message'))
                    .ok(this.$translate.instant('OK'))
                    .targetEvent(ev)
            ).then(() => {
                this.ContactManagerActionBarFactory.exportContactsToCSV(csvFileName, isAllContacts, this.selectedMediaListId, this.exportLimit, this.findString);
                this.SegmentTrackingService.trackEvent('export_contact', this.selectedMediaListId || 'All Contacts', numberOfContacts, 'ICM_contact_lists');
            });
        }
    };

    ListViewController.prototype.openDeleteContactsConfirmDialog = function openDeleteContactsConfirmDialog(contactIds, selectedMediaListId, findString) {
        this.$mdDialog.show({
            autoWrap: false,
            bindToController: true,
            fullscreen: false,
            locals: {
                deleteAll: false,
                showCheckbox: !this.allContacts && !this.ContactSelector.trueAllSelected,
                plural: ((contactIds.length > 1) || this.ContactSelector.trueAllSelected),
                deleteFromAllLists: this.allContacts
            },
            template: `<md-dialog id="delete-medialist-mini-modal" class="mw-mini-modal" aria-label="" layout="column">
                        <delete-medialist class="mw-mini-modal-wrapper" delete-from-all-lists="$ctrl.deleteFromAllLists" plural="$ctrl.plural" show-checkbox="$ctrl.showCheckbox" layout="column"></delete-medialist>
                    </md-dialog>`,
            // This is a globally available controller for the purposes of attaching locals for data binding
            controller: 'MwMiniModalDialogController',
            controllerAs: '$ctrl'
        }).then((shouldDeleteAll) => {
            if(contactIds.length > 0 && !this.ContactSelector.trueAllSelected) {
                this.removeContactsFromLists(contactIds, selectedMediaListId, shouldDeleteAll);
            } else {
                this.retrieveContactsForDeletion(selectedMediaListId, findString).then( idsToDelete => {
                    this.removeContactsFromLists(idsToDelete, selectedMediaListId, shouldDeleteAll);
                });
            }
        });
    };

    ListViewController.prototype.removeContactFromList = function removeContactFromList(contactId) {
        this.ContactStreamData.removeContactById(contactId);
        this.ContactSelector.deselectItemById(contactId);
    };

    ListViewController.prototype.viewContact = function viewContact(contact) {
        this.InfluencerContactService.setCurrentContact(contact);
        this.MiniProfileService.openMiniProfile(contact.id, true);

    };

    ListViewController.prototype.findfilterSearch = function findfilterSearch(searchTerm) {
        if(this.findFilterPromise){
            this.$timeout.cancel(this.findFilterPromise);
        }

        this.findString = searchTerm || '';

        //Only search if we have at least two characters, or reset if the filter text is gone
        if (this.findString.length > 2 || this.findString.length === 0) {

            // if we are clearing the filter, there is a split second where we show the incorrect empty state
            // we should anticipate that we are going to search to prevent this issue
            if(this.findString.length === 0) {
                this.ContactStreamData.isSearching = true;
            }

            this.findFilterPromise = this.$timeout(()=>{
                if(this.allContacts) {
                    this.getMasterListOfContacts();
                } else {
                    this.getContactsByMediaListId(this.selectedMediaListId);
                }
            }, 300);
        }
    };

    ListViewController.prototype.resetFindFilter = function resetFindFilter() {
        this.findFilterExpanded = false;
    };

    ListViewController.prototype.getContactsByMediaListId = function getContactsByMediaListId(mediaListId) {
        var query = {
            mediaListIds: [mediaListId],
            q: this.findString,
            sortBy: this.selectedSortBy,
            sortOrder: this.selectedSortOrder
        };
        this.isLoadingContacts = true;

        if(this.filters.unsubscribe === true) {
            query.filter = ['unsubscribed'];
        }

        this.updateStreamHeaderText();
        this.ContactSelector.deselectAll();

        this.ContactStreamData.getByMediaListIds(query).then(() => {
            if (!query.q) {
                this.totalMediaListContacts = this.ContactStreamData.totalContacts;
                this.isLoadingContacts = false;
                for (let i = 0; i < this.actions.length; i++) {
                    if (this.actions[i].name === 'outreach') {
                        this.actions[i].enabled = this.isOutreachActionEnabled();
                    }
                }
                this.ActionBarService.registerActions(this.actions);
            }
        });
    };

    ListViewController.prototype.getMasterListOfContacts = function getMasterListOfContacts(){
        var query = {
            q: this.findString,
            sortBy: this.selectedSortBy,
            sortOrder: this.selectedSortOrder
        };
        this.isLoadingContacts = true;

        if(this.filters.unsubscribe === true) {
            query.filter = ['unsubscribed'];
        }

        this.updateStreamHeaderText();
        this.ContactSelector.deselectAll();
        this.ContactStreamData.getMasterList(query).then(() => {
            this.totalMediaListContacts = this.ContactStreamData.totalContacts;
            this.isLoadingContacts = false;
        });
    };

    ListViewController.prototype.retrieveContactsForDeletion = function retrieveContactsForDeletion(selectedMediaListId, findString) {
        var contactIds = [],
            dataRetrievalPromise = (selectedMediaListId === '' || !selectedMediaListId) ? this.ContactManagerTagService.getAllContacts : this.ContactManagerTagService.getContactsByMediaListIds,
            query = {
                mediaListIds: (selectedMediaListId === '' || !selectedMediaListId) ? false : [selectedMediaListId],
                q: findString || '',
                pageSize: this.ContactSelector.allSelected ? this.ContactStreamData.totalContacts : 25
            };

        if(this.filters.unsubscribe === true) {
            query.filter = ['unsubscribed'];
        }

        return new Promise((resolve, reject)=>{
            dataRetrievalPromise(query).then(results => {
                if(results.hits && results.hits.length > 0) {
                    contactIds = results.hits.map(record => record.id);
                }

                resolve(contactIds);
            }).catch((err) => {
                reject(err);
            });
        });
    };

    ListViewController.prototype.removeContactsFromLists = function removeContactsFromLists(contactIds = [], selectedMediaListId, deleteFromAll) {
        let privateContacts = this.getPrivateContacts(contactIds),
            getAllTagsPromise = deleteFromAll || this.allContacts ? this.ContactManagerTagService.getAllTags() : Promise.resolve([{id: selectedMediaListId}]),
            afterRemovePromise = (((this.allContacts || deleteFromAll) && privateContacts.length !== 0)) ? this.InfluencerContactService.deletePrivateContacts(privateContacts) : Promise.resolve();

            return getAllTagsPromise.then((mediaLists) => {
                return this.ContactManagerTagService.bulkRemoveContactsFromTags(mediaLists.map(list => {return list.id; }), contactIds);
            }).then(() => {
                return afterRemovePromise.then(() => {
                    this.showToastMessage(this.$translate.instant('icm-web__delete-modal--success-message'));

                    if (this.allContacts) {
                        this.getMasterListOfContacts();
                    } else {
                        this.getContactsByMediaListId(selectedMediaListId);
                    }
                });
            }).catch(() => {
                this.ContactManagerFlashService.flashError('Failure. Your contacts have not been deleted.');
            });
    };

    ListViewController.prototype.highlightSelectedContact = function highlightSelectedContact(cardContactID) {
        return cardContactID === this.MiniProfileService.miniProfileId;
    };

    ListViewController.prototype.getPrivateContacts = function getPrivateContacts(contactIds){
        let privateContacts = [];

        this.ContactStreamData.contactArray.forEach((contactObj)=>{
            if(contactIds.indexOf(contactObj.id) > -1 && contactObj.systemData.policies.storage.private) {
                privateContacts.push(contactObj.id);
            }
        });

        return privateContacts;
    };

    ListViewController.prototype.compose = function compose() {
        this.ContactManagerActionBarFactory.compose(this.setRecipients.bind(this));
    };

    ListViewController.prototype.setRecipients = function setRecipients() {
        return this.$q(function(resolve) {
            var selectedContacts = this.ContactSelector.selectedItems,
                mediaListId = (this.mediaListName.indexOf(this.DEFAULT_MEDIA_LIST) === 0) ? '' : this.selectedMediaListId,
                findString = (!this.findString || this.findString.length <= 2) ? '' : this.findString,
                totalContactsSelected = Object.keys(this.ContactSelector.selectedItems).length,
                query;

            if ((this.ContactSelector.trueAllSelected && this.ContactStreamData.totalContacts === this.totalMediaListContacts) || (!this.ContactSelector.trueAllSelected && totalContactsSelected === this.totalMediaListContacts)) {
                query = {
                    id: mediaListId,
                    name: this.mediaListName
                };

                this.ICMEmailService.setMediaListRecipients([query]);
            } else if (this.ContactSelector.trueAllSelected) {
                query = {
                    mediaListIds: mediaListId === '' ? false : [mediaListId],
                    q: findString,
                    pageSize: this.ContactSelector.allSelected ? this.ContactStreamData.totalContacts : 25
                };

                this.ICMEmailService.setContactRecipientsQuery(query);
            } else {
                var selectedContactArray = Object.keys(selectedContacts).map(function(selectedContactKey) {
                    return selectedContacts[selectedContactKey];
                });

                this.ICMEmailService.setContactRecipients(selectedContactArray);
            }

            resolve();
        }.bind(this));
    };

    ListViewController.prototype.goToSearchPage = function goToSearchPage() {
        this.ContactManagerNavigationService.goToSearch();
    };

    ListViewController.prototype.goToKeywordSearchPage = function goToKeywordSearchPage() {
        this.ContactManagerNavigationService.goToKeywordSearch();
    };

    ListViewController.prototype.goToDirectorySearchPage = function goToDirectorySearchPage() {
        this.ContactManagerNavigationService.goToDirectorySearch();
    };

    ListViewController.prototype.goToUpsellPage = function goToUpsellPage() {
        this.ContactManagerNavigationService.goToUpsellPage();
    };

    ListViewController.prototype.getSelectedCount = function getSelectedCount(selectedItems) {
        return Object.keys(selectedItems).length;
    };

    ListViewController.prototype.resetSelections = function resetSelections(){
        this.ContactSelector.deselectAll();
    };

    ListViewController.prototype.refreshMediaList = function refreshMediaList() {
        let _this = angular.element(document.getElementsByClassName('contactListPage')).scope().listController;
        _this.ContactSelector.deselectAll();
        _this.setMediaList(_this.selectedMediaListId);
        _this.ContactManagerTagService.updateContactMediaLists(_this.ContactStreamData.contactArray, [_this.ContactSelector.selectedItems], [_this.selectedMediaListId]);
    };
    function getCriteria(query, pageSize, findString) { // jshint ignore:line
        var criteria = {};
        angular.extend(criteria, query, {
            page: 0,
            pageSize: pageSize,
            q: findString
        });

        return criteria;
    }

    ListViewController.prototype.tagSelectedContacts = function tagSelectedContacts() {
        let selectedContactIds = Object.keys(this.ContactSelector.selectedItems);

        if(this.ContactSelector.trueAllSelected && this.ContactStreamData.totalContacts > this.MAX_MEDIALIST_LIMIT || selectedContactIds.length  > this.MAX_MEDIALIST_LIMIT) {
            this.openLimitWarningModal();
        } else {
            window.addEventListener('icm-lists-updated', this.refreshMediaList, {once: true});
            var request;
            if(this.ContactSelector.trueAllSelected === true) {
                if (this.selectedMediaListId) { //opens modal when true Selecting All from a media list
                    request = {
                        method: 'POST',
                        url: this.ICM_CONTACT_SERVICE_URL + '/v2/contacts/medialist/' + this.selectedMediaListId,
                        headers: {
                            'x-api-key': this.ICM_CONTACT_SOURCE_SERVICE_API_KEY
                        },
                        data: {
                            'textFilter': this.ContactStreamData.query.q
                        }
                    };
                } else { //opens modal when true Selecting All in "View all Contacts"
                    request = {
                        method: 'POST',
                        url: this.CONTACT_MANAGER_MEDIA_LIST_URL + '/getAllContacts',
                        data: {
                            'q': this.ContactStreamData.query.q,
                            'page': 0,
                            'pageSize': this.MAX_MEDIALIST_LIMIT,
                            'onlyIds': true
                        }

                    };
                }
            }
            this.ContactManagerTagService.addToMediaListModal(request, selectedContactIds);
        }
    };

   ListViewController.prototype.openLimitWarningModal = function() {
        let manageListLimitWarning = document.querySelector('manage-list-limit-warning');
        manageListLimitWarning.open();
   };

    ListViewController.prototype.nextPageContacts = function nextPageContacts() {
        this.ContactStreamData.nextPage().then(function() {
            if(this.ContactSelector.allSelected && this.ContactStreamData.contactArray.length > 25) {
                this.ContactSelector.selectAllForNextPage(this.ContactStreamData.contactArray, null, null, this.predictionContactFilter);
            }
        }.bind(this))
        .catch(function() {});
    };

    ListViewController.prototype.showToastMessage = function(msg){
        this.$mdToast.show(
            this.$mdToast.mwSimpleTimed()
                .textContent(msg)
        );
    };

    ListViewController.prototype.composeEmailToList = function(mediaListId) {
        var _this = this;

        _this.ICMEmailService.getIcmApprovedSenders()
            .then(function onGetApprovedSendersSuccess(sendersList) {
                if(sendersList.length > 0) {
                    _this.ContactManagerNavigationService.goToOutreach(mediaListId);
                } else {
                    var dialogTitle = _this.translationService.getLocalizedString('Compose Email');

                    _this.DialogService.dialog(dialogTitle, 'icm-web/views/partials/email_unapproved_dialog', {}, function callback() {
                        // currently this is service is only ever called by ICM-WEB, so we always load up F-W. in this ends up being used in FW as well, we will need to revisit this logic.
                        _this.ContactManagerNavigationService.redirectToFairhairWeb('/settings/email');
                    });
                }
            })
            .catch(function onGetApprovedSendersFail() {
                _this.DialogService.flashError(_this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
            });
    };

    ListViewController.prototype.showEditDialog = function showEditDialog() {
        let _this = this;

        this.$mdDialog.show({
            bindToController: true,
            locals: {
                mediaList: {
                    id: this.selectedMediaListId,
                    name: this.mediaListName,
                    description: this.mediaListDescription
                },
                duplicateError: false,
                cancelDialog: function() {
                    _this.$mdDialog.cancel();
                },
                okDialog: function(updatedMediaList) {
                    let mediaListId = updatedMediaList.id;
                    let mediaListName = updatedMediaList.name;
                    let mediaListDescription = updatedMediaList.description;

                    this.duplicateError = false;

                    _this.ContactManagerTagService.updateMediaList(mediaListId, mediaListName, mediaListDescription)
                        .then(() => {
                            _this.setMediaList(mediaListId);
                            _this.$mdDialog.hide();

                            _this.$mdToast.show(
                                _this.$mdToast.mwSimpleTimed().textContent(_this.successEditListToastMessage)
                            );
                        })
                        .catch((error) => {
                            // somewhere along the line we decided error.status just wasn't cutting it, we thought error.data.error.reason just rolled off the tongue
                            if(error.status === 409 || (error && error.data && error.data.error && error.data.error.reason === 409)) {
                                this.duplicateError = true;
                            } else {
                                _this.$mdDialog.hide();
                                _this.DialogService.flashError(_this.$translate.instant('Error. There was a problem with your request. Please try again later.'));
                            }
                        });
                },
            },
            template: `
                <md-dialog id="icm-media-list-update-modal" class="mw-mini-modal" aria-label="" layout="column">
                    <mw-media-list-update-modal class="mw-mini-modal-wrapper" layout="column" media-list="$ctrl.mediaList" duplicate-error="$ctrl.duplicateError" ok-callback="$ctrl.okDialog(updatedMediaList)" cancel-callback="$ctrl.cancelDialog()"></mw-media-list-update-modal>
                </md-dialog>
            `,
            // This is a globally available controller for the purposes of attaching locals for data binding
            controller: 'MwMiniModalDialogController',
            controllerAs: '$ctrl'
        });
    };
}());
